__turbopack_context__.v({
  "badge": "SignalBadge-module-scss-module__L1lgJW__badge",
  "cancelled": "SignalBadge-module-scss-module__L1lgJW__cancelled",
  "eventEnded": "SignalBadge-module-scss-module__L1lgJW__eventEnded",
  "postponed": "SignalBadge-module-scss-module__L1lgJW__postponed",
  "soldOut": "SignalBadge-module-scss-module__L1lgJW__soldOut",
});
